import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"
import Dimensions from "./Trousers/Dimensions"
import Specifications from "./Trousers/Specifications"
import Correction from "./Trousers/Correction"
import DateInput from "components/Common/DateInput"
import "../style.css"
import { BranchOptions, FabricOptions } from "components/CustomSelect"
import DimensionInput from "components/Common/DimensionInput"

function TabTourses(props) {
  const { config } = props
  const { handleCommonInput, handlePantsInput } = config
  return (
    <Row>
      <Col xl={9} md={12}>
        <Card>
          <CardBody>
            <Row>
              <Col sm={6} className="pe-0">
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">店舗</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadBranch}
                          defaultValue={config.branchValue}
                          value={config.branchValue}
                          onChange={e => handleCommonInput(e, "storeId")}
                          formatOptionLabel={item => (
                            <BranchOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">受注日</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          className="form-control"
                          // value={config.payload.orderDate}
                          onChange={e => handleCommonInput(e[0], "orderDate")}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">顧客名</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync={true}
                          loadOptions={config.loadCustomer}
                          defaultOptions={config.customerOptions}
                          defaultValue={config.customerValue}
                          value={config.customerValue}
                          onChange={e => handleCommonInput(e, "customerId")}
                          // isDisabled={config.payload.storeId === 0}
                          isDisabled={!!config.payload.guest}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">生地商社</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadFabricTrading}
                          defaultValue={config.fabricTradingValue}
                          value={config.fabricTradingValue}
                          onChange={e =>
                            handleCommonInput(e, "fabricCompanyId")
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">生地</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadFabric}
                          defaultValue={config.fabricValue}
                          defaultOptions={config.fabricOption}
                          value={config.fabricValue}
                          onChange={e => handleCommonInput(e, "fabricId")}
                          isDisabled={
                            !config.fabricTradingValue ||
                            config.fabricTradingValue.value === ""
                          }
                          formatOptionLabel={item => (
                            <FabricOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: 105, padding: 6 }}>
                        <p className="mb-0">生地ランク</p>
                      </td>
                      <td
                        className="d-flex align-items-center justify-content-between"
                        style={{ padding: 6 }}
                      >
                        <input
                          disabled
                          value={config.rank?.rank}
                          className="form-control w-100"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: 5 }}>
                        <p style={{ width: 107 }} className="mb-0">
                          生地巾
                        </p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          disabled
                          value={config.rank?.clothWidth}
                          className="form-control w-100"
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 107 }}>
                        <p className="mb-0">仮縫い</p>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div>
                            <Input
                              defaultChecked={config.payload.basting}
                              // onClick={() => config.onClickBusting(true)}
                              onChange={e =>
                                handleCommonInput(e, "basting", true)
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOn"
                            />
                            <Label htmlFor="bastingOn" className="mb-0">
                              あり
                            </Label>
                          </div>

                          <div className="ms-5">
                            <Input
                              defaultChecked={!config.payload.basting}
                              // onClick={() => config.onClickBusting(false)}
                              onChange={e =>
                                handleCommonInput(e, "basting", false)
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOff"
                            />
                            <Label htmlFor="bastingOff" className="mb-0">
                              なし
                            </Label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">釦</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          style={{ height: 33 }}
                          className="form-control"
                          defaultValue={config.payload.pants.button}
                          name="button"
                          onChange={e => handlePantsInput(e, "button")}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105 }}>
                        <p className="mb-0">プライス税別</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        {/* <input
                          style={{ height: 33 }}
                          className="form-control"
                          name="priceWithoutTax"
                          defaultValue={
                            config.payload.pants.priceWithoutTax || ""
                          }
                          value={config.payload.pants.priceWithoutTax || ""}
                          onChange={e => handlePantsInput(e, "priceWithoutTax")}
                          type="number"
                        /> */}
                        <DimensionInput
                          name="priceWithoutTax"
                          defaultValue={
                            config.payload.pants.priceWithoutTax || ""
                          }
                          value={config.payload.pants.priceWithoutTax || ""}
                          onValueChange={(val, name) =>
                            handlePantsInput(val, name)
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6} className="ps-0">
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td>
                        <p className="mb-0">種別</p>
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-start">
                          <div>
                            <Input
                              defaultChecked={config.payload.type === "Bespoke"}
                              onChange={e => handleCommonInput(e, "type")}
                              className="me-2 me-xl-1"
                              type="radio"
                              id="BeSpoke"
                              name="type"
                              value="Bespoke"
                            />
                            <Label
                              htmlFor="BeSpoke"
                              className="mb-0"
                              style={{ fontSize: 11 }}
                            >
                              Bespoke
                            </Label>
                          </div>

                          <div className="ms-5 ms-xl-3">
                            <Input
                              defaultChecked={config.payload.type === "MTM"}
                              onChange={e => handleCommonInput(e, "type")}
                              className="me-2 me-xl-1"
                              type="radio"
                              name="type"
                              id="MTM"
                              value="MTM"
                            />
                            <Label
                              className="mb-0"
                              htmlFor="MTM"
                              style={{ fontSize: 11 }}
                            >
                              MTM
                            </Label>
                          </div>
                          <div className="ms-5 ms-xl-3">
                            <Input
                              type="radio"
                              defaultChecked={config.payload.type === "RTW"}
                              onChange={e => handleCommonInput(e, "type")}
                              className="me-2 me-xl-1"
                              name="type"
                              id="RTW"
                              value="RTW"
                            />
                            <Label
                              className="mb-0"
                              htmlFor="RTW"
                              style={{ fontSize: 11 }}
                            >
                              RTW
                            </Label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td colSpan={2}>
                        <Input style={{ opacity: 0 }} type="radio" />
                      </td>
                    </tr>
                    <tr style={{ height: 54, opacity: config.guestHidden }}>
                      <td style={{ padding: 5, width: 115 }}>
                        <Input
                          defaultChecked={config.payload.guest}
                          onChange={e => handleCommonInput(e, "guest")}
                          className="ms-2"
                          name="guest"
                          type="checkbox"
                          id="新規お客様"
                          disabled={!config.guestHidden}
                        />
                        <Label className="ms-2 mb-0" htmlFor="新規お客様">
                          新規お客様
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          placeholder="ゲスト名を入力"
                          style={{ height: 33 }}
                          className="form-control"
                          name="guestName"
                          value={config.payload.guestName}
                          onChange={e => handleCommonInput(e, "guestName")}
                          disabled={!config.payload.guest}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: 5 }}>
                        <Label className="ms-2 mb-0" style={{ fontSize: 11 }}>
                          生地年度
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.yearOption}
                          defaultValue={config.yearValue}
                          value={config.yearValue}
                          onChange={e => handleCommonInput(e, "year")}
                          isDisabled={
                            !config.fabricTradingValue ||
                            config.fabricTradingValue?.value === ""
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: 5 }}>
                        <Label className="ms-2 mb-0" style={{ fontSize: 11 }}>
                          生地シーズン
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.seasonOption}
                          defaultValue={config.seasonValue}
                          value={config.seasonValue}
                          onChange={e => handleCommonInput(e, "seasonId")}
                          isDisabled={
                            !config.yearValue?.value ||
                            !config.fabricValue?.value
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ padding: 5 }}>
                        <Label style={{ width: 109 }} className="ms-2 mb-0">
                          混率
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          disabled
                          value={config.rank?.mixedRatio}
                          style={{ height: 33 }}
                          className="form-control"
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td
                        style={{
                          padding: 6.5,
                          position: "relative",
                        }}
                      >
                        <Label className="ms-2 mb-0">用尺</Label>
                      </td>
                      <td style={{ padding: 5, position: "relative" }}>
                        <input
                          defaultValue={config.payload.pants.scale || ""}
                          value={config.payload.pants.scale || ""}
                          name="scale"
                          onChange={e => handlePantsInput(e, "scale")}
                          style={{ height: 33 }}
                          className="form-control scale-input"
                          type="number"
                        />
                        <p
                          style={{
                            position: "absolute",
                            right: 15,
                            top: 15,
                            opacity: 0.5,
                          }}
                        >
                          M
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 107 }}>
                        <p className="mb-0">仮縫い日</p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          className="form-control"
                          // value={config.payload.fittingDate}
                          onChange={e => handleCommonInput(e[0], "fittingDate")}
                          disabled={!config.payload.basting}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ padding: 5.5 }}>
                        <Label style={{ width: 100 }} className="ms-2 mb-0">
                          糸色
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <Input
                          // onChange={config.onChange}
                          onChange={e => handlePantsInput(e, "threadColor")}
                          value={config.payload.pants.threadColor}
                          name="threadColor"
                          style={{ height: 33 }}
                          className="form-control"
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ padding: 5 }}>
                        <Label style={{ width: 100 }} className="ms-2 mb-0">
                          プライス税込
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        {/* <input
                          style={{ height: 33 }}
                          className="form-control"
                          disabled
                          value={config.payload.pants.priceTaxIncluded || ""}
                        /> */}

                        <DimensionInput
                          disabled
                          name="priceWithoutTax"
                          value={config.payload.pants.priceTaxIncluded || ""}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col xl={3} md={6}>
        <Card>
          <CardBody>
            <Table bordered>
              <tbody>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">納品方法</p>
                    <SelectBox
                      options={config.deliveryMethodOptions}
                      value={config.pantsDeliveryMethod}
                      isClearable={false}
                      onChange={e => handlePantsInput(e, "deliveryMethod")}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">サンプル</p>
                    <Input
                      defaultChecked={config.payload.pants.sample}
                      // onChange={config.onChangeSample}
                      onChange={e => handlePantsInput(e, "sample")}
                      className="me-2"
                      type="checkbox"
                      id="サンプル"
                    />
                    <Label className="mb-0" htmlFor="サンプル">
                      サンプル
                    </Label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 10 }}>
                    <p className="mb-0">予定納品日</p>
                    <DateInput
                      value={""}
                      onChange={e =>
                        handlePantsInput(e, "scheduledDeliveryDate")
                      }
                      className="form-control"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>

      <Col sm={12}>
        <Card>
          <CardBody>
            <Row className="">
              <Col xl={7} sm={8} className="pe-0">
                <p>寸法</p>
                <Dimensions config={config} />
              </Col>
              {/* ラジオボタン = Radio, プルダウン : dropdown/elect, チェックボックス : checkbox, TEXT  */}
              <Col xl={5} sm={4}>
                <p>補正</p>
                {config?.orderSheets?.pants?.corrections?.length ? (
                  <Correction config={config} />
                ) : null}
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <p>仕様</p>
            {config?.orderSheets?.pants?.specifications?.length ? (
              <Specifications config={config} />
            ) : null}
          </CardBody>
        </Card>
      </Col>

      {config.orderSheets && config.orderSheets.hasMemo ? (
        <Col sm={12}>
          <Card>
            <CardBody>
              <p>メモ </p>
              <textarea
                className="form-control"
                rows={8}
                onChange={e => handleCommonInput(e, "memo")}
                value={config.payload.memo}
              ></textarea>
            </CardBody>
          </Card>
        </Col>
      ) : null}
    </Row>
  )
}

export default TabTourses
